import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useCallback, useRef, useState } from "react";
import { ApiContainer } from "../utils/api";
import { SET_API_DATA } from "../redux/constants";

const LearningContentContainer = ({ type, course_id, lesson_id }) => {
  const { api } = ApiContainer();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const from = queryParams.get("from");
  const name = queryParams.get("name");
  const learningContentData = useSelector(
    (state) => state.api.learningContentData
  );
  const LearningContentLoader = useSelector(
    (state) => state.api?.loader?.learningContentData
  );

  const [downloadingIndex, setDownloadingIndex] = useState(null);

  const fetchContentData = useCallback(async () => {
    if (!course_id) return;

    const endPoint = lesson_id
      ? `learning/course/${course_id}/lesson/${lesson_id}`
      : `learning/course-details/${course_id}`;

    const response = await api({
      method: "GET",
      endPoint,
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "learningContentData",
    });

    if (response?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          learningContentData: response?.data,
        },
      });
    } else {
      dispatch({
        type: SET_API_DATA,
        payload: {
          learningContentData: {},
        },
      });
    }
  }, [course_id, lesson_id]);

  const handleContentDownload = async (file, index) => {
    setDownloadingIndex(index);

    const url = file?.content_url;
    if (!url) {
      setDownloadingIndex(null);
      return;
    }

    const filename = file?.title || "downloaded-file";

    try {
      const response = await fetch(url, { mode: "cors" });
      if (!response.ok) throw new Error("Fetch failed");

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }

    setDownloadingIndex(null);
  };

  useEffect(() => {
    fetchContentData();
  }, [fetchContentData]);

  return {
    learningContentData,
    LearningContentLoader,
    downloadingIndex,
    handleContentDownload,
    from,
    name,
  };
};

export default LearningContentContainer;
